import { render, staticRenderFns } from "./marke-vozila.editor.vue?vue&type=template&id=3ef4d06a&scoped=true&"
import script from "./marke-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./marke-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4d06a",
  null
  
)

export default component.exports